<template>
	<div class="container-fluid" style="width:75%">

		<filter-bar
			v-if="allEmployees.length"
			:filters="filterBarFilters"
			v-on:filterChange="filterChange">

			<template v-slot:inline>
				<field
					label="Compare:"
					class="mr-4"
					col-class="col-auto"
					:params="{
					type: 'btn-group',
					buttons: [
						{ text: 'Date', value: 'date' },
						{ text: 'Costs', value: 'costs' },
						{ text: 'Quotes', value: 'quotes' },
					],
					disableNull: true
				}"
					v-model="tableLayout">
				</field>

				<field
					label="View:"
					col-class="col-auto"
					:params="{
					type: 'btn-group',
					buttons: [
						{ text: 'Table', value: 'table' },
						{ text: 'Chart', value: 'chart' }
					],
					disableNull: true
				}"
					v-model="view">
				</field>
			</template>

		</filter-bar>

		<!--- <hr style="width:80%"/> --->

		<!---------- Start of Table View ---------->

		<div v-if="view == 'table'" class="justify-content-center">

			<table-list
				class="display-group"
				:record-name="recordName"
				:records="mutatedUsers"
				:fields="tableFields"
				:sortable="true">
			</table-list>

		</div>

		<!---------- End of Table View ---------->



		<!---------- Start of Chart View ---------->

		<div v-if="view == 'chart'" class="justify-content-center mt-3">

			<service-report-chart-view
				:users="mutatedUsers"
				:compare-by="tableLayout"
			></service-report-chart-view>

		</div>

		<!---------- End of Chart View ---------->

	</div>
</template>

<script type="text/javascript">

import Toolbar from "@/layout_fragments/Toolbar"
import ProjectsToolbarControls from "@/pages/project/ProjectsToolbarControls"
import FilterBar from "@/components/FilterBar"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import Chart from "@/components/Chart"
import Widget from "@/components/Widget"
import ServiceReportChartView from "@/components/ServiceReportChartView"

import Utilities from "@/mixins/Utilities"

export default {
	name: "ReportsServicesEmployees",
	components: {
		Toolbar,
		ProjectsToolbarControls,
		FilterBar,
		TableList,
		Field,
		Chart,
		Widget,
		ServiceReportChartView
	},
	mixins: [Utilities],
	props: [
		"compare",
		"allDataFetched",
		"allServices",
		"allInvoices",
		"allBatchInvoices",
		"allEmployees",
		"allCustomers",

		"refilterData"	// Int incremented to force refilter after fetching more data
	],
	data() {
		return {
			filters: [],			// eg. [["completed >", "2010-03-30"], [...], [...], ... ]
			filteredServices: [],	// eg. [Service(A), Service(B)....]
			filteredUsers: [],		// eg. [Employee(A), Employee(B)....] or [Contact(A), Contact(B)....]

			tableLayout: "date",
			view: "table",

			dateTableFields: [
				{label: "Name", key: "name"},
				{label: "First Service Completed", key: "firstServiceDate", sortBy: "date"},
				{label: "Last Service Completed", key: "lastServiceDate", sortBy: "date"},
				{label: "# Completed", key: "serviceCount", align: "center"},
				{label: "Total Costs", key: "totalCosts", sortBy: "float", align: "right"},
				{label: "Total Revenue", key: "totalRevenue", sortBy: "float", align: "right"},
				{label: "Total Profits", key: "totalProfits", sortBy: "float", align: "right"},
			],

			leadTableFields: [
				{label: "Name", key: "name"},
				{label: "# Completed as a Lead", key: "serviceCount", sortBy: "float", align: "right"},
				{label: "Total Costs", key: "totalCosts", sortBy: "float", align: "right"},
				{label: "Total Revenue", key: "totalRevenue", sortBy: "float", align: "right"},
				{label: "Total Profits", key: "totalProfits", sortBy: "float", align: "right"},
			],

			quotesTableFields: [
				{label: "Name", key: "name"},
				{label: "# Quotes Pending", key: "quotesPending", align: "right"},
				{label: "# Quotes Declined", key: "quotesDeclined", align: "right"},
				{label: "# Quotes Completed", key: "quotesCompleted", align: "right"},
				{label: "Total # Quotes", key: "quotesTotal", align: "right"},
				{label: "Total Costs", key: "totalCosts", sortBy: "float", align: "right"},
				{label: "Total Revenue", key: "totalRevenue", sortBy: "float", align: "right"},
				{label: "Total Profits", key: "totalProfits", sortBy: "float", align: "right"}
			],

			costsTableFields: [
				{label: "Name", key: "name"},
				{label: "Total Material Costs", key: "totalMaterial", sortBy: "float", align: "right"},
				{label: "Total Labour Costs", key: "totalLabour", sortBy: "float", align: "right"},
				{label: "Total Equipment Costs", key: "totalEquipment", sortBy: "float", align: "right"},
				{label: "Total Permit Costs", key: "totalPermit", sortBy: "float", align: "right"},
				{label: "Total Taxes Collected", key: "totalTaxes", sortBy: "float", align: "right"},
				{label: "Total Costs", key: "totalCosts", sortBy: "float", align: "right"},
				{label: "Total Revenue", key: "totalRevenue", sortBy: "float", align: "right"},
				{label: "Total Profits", key: "totalProfits", sortBy: "float", align: "right"},
				{label: "Profit Margin", key: "profitMargin", sortBy: "htmlFloat", align: "right"},
			],

		}
	},

	computed: {

		recordName() {
			if (this.compare == "employees")
				return "Employee"
			else if (this.compare == "customers")
				return "Customer"
			else
				return "INVALID"
		},

		tableFields() {
			// Returns the orientation of the table depending on the selected button

			if (this.tableLayout == "date")
				return this.dateTableFields
			else if (this.tableLayout == "lead")
				return this.leadTableFields
			else if (this.tableLayout == "quotes")
				return this.quotesTableFields
			else if (this.tableLayout == "costs")
				return this.costsTableFields

			return []	// Not valid? No fields
		},

		employeeOptions() {
			return this.optionify(this.allEmployees, 'name', true)
		},

		customerOptions() {
			return this.optionify(this.allCustomers, 'name', true)
		},

		filterBarFilters() {
			if (this.compare == 'employees') {
				return [
					{ type: 'date', label: 'Completed:', prop: 'completed', initialDateRange: 'month' },
					{ type: 'select-multi', label: 'Employees:', options: this.employeeOptions, prop: 'name' }
				]
			} else if (this.compare == 'customers') {
				return [
					{ type: 'date', label: 'Completed:', prop: 'completed', initialDateRange: 'month' },
					{ type: 'select-multi', label: 'Customers:', options: this.customerOptions, prop: 'name' }
				]
			}

			return []
		},

		mutatedUsers() {

			return this.filteredUsers.map(user => {

				// Format dates
				if ('firstService' in user && user.firstService)
					user.firstServiceDate = this.formatDateTimeToLocal(user.firstService)
				else
					user.firstServiceDate = ""

				if ('lastService' in user && user.lastService)
					user.lastServiceDate = this.formatDateTimeToLocal(user.lastService)
				else
					user.lastServiceDate = ""

				// Calculate totals
				user.quotesTotal = user.quotesPending + user.quotesDeclined + user.quotesCompleted
				user.totalCosts = user.totalMaterial + user.totalEquipment + user.totalLabour + user.totalPermit
				user.totalProfits = user.totalRevenue - user.totalCosts

				if (user.totalRevenue && user.totalProfits)
					user.profitMargin = user.totalProfits / user.totalRevenue * 100
				else
					user.profitMargin = 0


				// Format money
				user.totalMaterial = 'totalMaterial' in user ? 		user.totalMaterial.toCurrency() : "0.00"
				user.totalEquipment = 'totalEquipment' in user ? 	user.totalEquipment.toCurrency() : "0.00"
				user.totalLabour = 'totalLabour' in user ? 			user.totalLabour.toCurrency() : "0.00"
				user.totalPermit = 'totalPermit' in user ? 			user.totalPermit.toCurrency() : "0.00"
				user.totalCosts = 'totalCosts' in user ? 			user.totalCosts.toCurrency() : "0.00"
				user.totalRevenue = 'totalRevenue' in user ? 		user.totalRevenue.toCurrency() : "0.00"
				user.totalTaxes = 'totalTaxes' in user ? 			user.totalTaxes.toCurrency() : "0.00"
				user.totalProfits = user.totalProfits.toCurrency()
				user.profitMargin = user.profitMargin.toFixed(2)


				let profitMarginColor = ""
				let profitMarginIcon = ""

				if (user.profitMargin < 0) {
					profitMarginColor = "text-danger"
					profitMarginIcon = "fa fa-caret-down"
				} else if (user.profitMargin > 0) {
					profitMarginColor = "text-success"
					profitMarginIcon = "fa fa-caret-up"
				}

				user.profitMargin = "<span class='" + profitMarginColor + "'> " +
					"<i class='" + profitMarginIcon + "'></i>" +
					" " + user.profitMargin + " %" +
					"</span>"


				return user
			})
		},

		mutatedServices() {

			return this.filteredServices.map(service => {
				if ('assigned_to' in service && service.assigned_to) {
					let assigned = this.allEmployees.find(emp => emp.id == service.assigned_to)
					if (assigned)
						service.assignedTo = assigned.first_name + " " + assigned.last_name
				}

				if ('completed' in service && service.completed) {
					service.completedDate = this.formatDateTimeToLocal(service.completed)
				}

				return service
			})
		},


	},
	watch: {
		refilterData() {
			this.$nextTick(() => {
				this.filterData()
			})
		}
	},
	methods: {

		filterChange(filters) {
			this.filters = filters
			this.filterData()
		},

		filterData() {
			// Filter employees and services
			// Not all data has been fetched yet and requested date is out of bounds?
			// Fetch the rest of the data, then filter accordingly

			if (!this.allDataFetched) {
				let dateFilter = this.filters.find(filter => filter[0] == "completed >")
				let oneMonthAgo = this.moment().subtract(1, 'month').format("YYYY-MM-DD")
				if (dateFilter && (!dateFilter[1] || dateFilter[1] < oneMonthAgo)) {	// Date further back than a month ago? Update first
					this.$emit("fetchAllData")
					return									// Exit (we come back in fetchData after data is retrieved)
				}
			}

			let serviceFilters = this.filters.filter(item => {
				let prop = item[0].split(' ')[0]
				return (prop == 'completed') || (prop == 'job_num')
			})

			this.$nextTick(() => {
				serviceFilters.push(["is_canceled", "0"])	// Do not include cancelled

				let userFilters = this.filters.filter(item => {
					let prop = item[0].split(' ')[0]
					return (prop == 'name')
				})

				this.filteredServices = this.filterObjects(this.allServices, serviceFilters)

				if (this.compare == 'employees') {
					this.filteredUsers = this.filterObjects(this.allEmployees, userFilters)
					this.mapUsersToServices(this.filteredUsers, "assigned_to")
				} else if (this.compare == 'customers') {
					this.filteredUsers = this.filterObjects(this.allCustomers, userFilters)
					this.mapUsersToServices(this.filteredUsers, "customer_id")
				}


			})
		},

		mapUsersToServices(userList, idProperty) {
			/*
			For a list of users (employees, customers, etc) and a list of services,
			calculates the total values for each user/service.
			Sets services/serviceCount, first/last service dates, totals for costs, and quotes

			Params:
			    userList - a list of users (employees, customers, etc) filtered before this is called
			    idProperty - userList[user].id === serviceList.service.idProperty
			 */

			// Add 'services' field to each employee
			userList.map(user => {
				user.services = []
				user.serviceCount = 0

				// Zero out the date values
				user.firstService = ""
				user.lastService = ""

				// Zero out all the cost values
				user.totalMaterial = 0
				user.totalEquipment = 0
				user.totalLabour = 0
				user.totalPermit = 0
				user.totalTaxes = 0
				user.totalRevenue = 0

				// Zero out all the quote values
				user.quotesPending = 0
				user.quotesDeclined = 0
				user.quotesCompleted = 0
				return user
			})

			this.filteredServices.forEach(service => {

				// Assigned to exists?
				if (idProperty in service && service[idProperty]) {
					let user = this.filteredUsers.find(user => user.id == service[idProperty])

					// Valid user? Add service ID to their list (NOT JOB ID), increment count
					if (user) {
						user.services.push(service.job_num)
						user.serviceCount += 1

						// Update first/last completed
						if (!user.firstService || (service.completed && user.firstService > service.completed))
							user.firstService = service.completed
						if (service.completed && user.lastService < service.completed)
							user.lastService = service.completed

						// Update costs
						if ("total_material_costs" in service && service.total_material_costs != null)
							user.totalMaterial += parseFloat(service.total_material_costs)
						if ("total_equipment_costs" in service && service.total_equipment_costs != null)
							user.totalEquipment += parseFloat(service.total_equipment_costs)
						if ("total_labour_costs" in service && service.total_labour_costs != null)
							user.totalLabour += parseFloat(service.total_labour_costs)
						if ("permit_cost" in service && service.permit_cost != null)
							user.totalPermit += parseFloat(service.permit_cost)

						// Update quotes if quote exists for service
						if ("quote" in service && service.quote) {
							if ("quote_rejected" in service.quote && service.quote.quote_rejected == "1")
								user.quotesDeclined += 1			// Quote declined
							else if ("quote_status" in service.quote && service.quote.quote_status == "Accepted")
								user.quotesCompleted += 1
							else if ("quote_status" in service.quote &&
								(service.quote.quote_status == "Pending Approval" || service.quote.quote_status == ""))
								user.quotesPending += 1
						}

						user.totalRevenue += parseFloat(service.revenue)
						user.totalTaxes += parseFloat(service.total_taxes)

						/*
						// Update revenue if invoice exists for service
						if ("invoice" in service && service.invoice) {

							if ("pretax_total" in service.invoice && service.invoice.pretax_total)
								user.totalRevenue += parseFloat(service.invoice.pretax_total)
							if ("taxable_total" in service.invoice && service.invoice.taxable_total &&
								"applied_sales_tax_json" in service.invoice && service.invoice.applied_sales_tax_json) {
								let taxObject = JSON.parse(service.invoice.applied_sales_tax_json)

								// This is where tax is applied
								// In the future if different taxes are used, this would be where to edit
								if ("H.S.T. # 846734945" in taxObject) {
									user.totalTaxes += (parseFloat(service.invoice.taxable_total) *
										parseFloat(taxObject["H.S.T. # 846734945"]))
								}
							}
						}

						 */

					}
				}
			})
		}
	}
}
</script>

<style scoped>

.display-group {
	padding-bottom: 20%;
}

</style>
